import React, { Component } from 'react'
import {connect} from "react-redux";
import {actions} from "../../actions";

import AddedReviewers from '../users/AddedReviewers'
import ArtifactPreview from './ArtifactPreview';
import AssessmentRubricDisplay from '../rubric/AssessmentRubricDisplay';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {withStyles} from "@material-ui/core/styles/index";
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader';
import _ from 'lodash';

const styles = {
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    title: {
        marginTop: 5,
        marginBottom: -2,
        fontSize: 12,
    },
    p: {
        marginBottom: 5
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }

};

class AssessmentReview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
    }

    componentDidMount() {
        if(this.props.form) {
            this.setState({loaded: true});
        }
    }

    componentWillReceiveProps(props) {
        if(this.props.form) {
            this.setState({loaded: true});
        }
    }

    renderTerms(terms) {
        let stringTerms =  _.map(terms, option => {
            return option.name;
        });
        let str = stringTerms.toString();
        return str.replace(/,/g, ', ');
    }

    render () {
        const { classes } = this.props;
        let visible = null;
        if (this.state.loaded) {
            visible =  (
                <div>
                    <div><Typography variant="h3" gutterBottom>
                        Review Assessment
                    </Typography></div>
                    <div className='row'>
                        <div className='columnLeft'>
                            <Card className={classes.card}>
                                <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                    Reviewers
                                </Typography>
                                <CardContent>
                                    <AddedReviewers hideRemove={true}/>
                                </CardContent>

                            </Card>
                        </div>
                        <div className='columnRight'>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Assessment Name
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.name.toString()}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        College
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.college.name.toString()}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Department
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.department.name.toString()}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Program
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.program.name.toString()}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Term
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.renderTerms(this.props.form.terms)}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Outcome
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.outcome.name.toString()}
                                    </Typography>

                                </CardContent>
                            </Card>
                        </div>
                    </div>

                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Artifacts
                        </Typography>
                        <CardContent>
                            <div className='row' style={{paddingBottom: '20px'}}>
                                <ArtifactPreview changed={false} hideActions={true}/>
                            </div>
                        </CardContent>

                    </Card>

                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Rubrics
                        </Typography>
                        <CardContent>
                            <div className='row' style={{paddingBottom: '20px'}}>
                                <AssessmentRubricDisplay />
                            </div>
                        </CardContent>

                    </Card>
                </div>
            )
        }

        return (
            <div>
                <Loader loaded={this.state.loaded}/>
                <br/>
                {visible}
            </div>
        )

    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        reviewers: state.reviewers,
        artifacts: state.artifacts,
        rubrics: state.rubrics,
        user: state.user
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(AssessmentReview));
